import React, { useState, useEffect, useContext } from "react";
import "./UserList.scss";
import StatusBar from "../../components/statusBar/StatusBar";
import dashboardApi from "../../services/dashboardApi";
import { AuthContext } from "../../context/AuthContext";
import { DndProvider } from "react-dnd";
import { TouchBackend } from 'react-dnd-touch-backend';
import StageUsers from "../../components/stage/StageUsers";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../components/loader/Loader";
const UserList = () => {
  useEffect(() => {
    setLoading(false);
  }, []);
  const [reloadStatusBar, setReloadStatusBar] = useState(false);
  const [loading, setLoading] = useState(true);
  const triggerStatusBarReload = () => {
    setReloadStatusBar(prevState => !prevState); // Toggle state to force re-render
  };
  return (
    <>
    {loading ? (
        <Loader />
      ) : (
    <DndProvider backend={TouchBackend} options={{enableMouseEvents:true}}>
      <div className="user-list schedules">
        <StatusBar showRoList={false} reload={reloadStatusBar}/>
        <div className="schedule-table">
          <StageUsers triggerStatusBarReload={triggerStatusBarReload}/>
        </div>
        {/* <ToastContainer autoClose={1500} /> */}
      </div>      
    </DndProvider>
    )}
    </>
  );
};

export default UserList;
